import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Simple radio button to embed to a form.
 *
 * @param {string} name - name of the radio. It is used to unselect the other
 *   radio buttons with the same name
 * @param {boolean} [isChecked] - When true, the radio is selected
 * @param {object} [attributes] - Optional attributes to add to the input
 */
export default class RadioFieldWidget extends Widget {
	constructor({ name, isChecked = false, attributes = {} }) {
		super(...arguments);

		this._name = name;
		this._isChecked = isChecked;
		this._attributes = attributes;
	}

	renderContentOn(html) {
		html.div(
			{ class: "form-check" },
			html.input({
				class: "form-check-input radio-field-input",
				type: "radio",
				name: this._name,
				checked: this._isChecked,
				...this._attributes,
			}),
		);
	}

	isChecked() {
		return this._isChecked;
	}

	check(bool) {
		this._isChecked = bool;
		this.update();
	}
}
